/**
 * This file may contain code that uses generative AI for code assistance, unit testing and/or entire functions.
 * The generative model(s) used may be a combination of GitHub Copilot, OpenAI ChatGPT or others.
 */

export default {
  command_intelligence_drawer_title: 'Command Intelligence',
  command_intelligence_drawer_resize_handle: 'Плъзнете, за да преоразмерите панела',
  command_intelligence_close_aria: 'Затвори асистента',
  command_intelligence_send_aria: 'Изпрати съобщение',
  command_intelligence_stop_aria: 'Спри отговора',
  command_intelligence_composer_input_aria: 'Съобщение към Command Intelligence',
  command_intelligence_drawer_more_options: 'Още опции',
  command_intelligence_dock_position: 'Позиция на закрепване',
  command_intelligence_dock_left: 'Ляво',
  command_intelligence_dock_right: 'Дясно',
  command_intelligence_dock_top: 'Горе',
  command_intelligence_dock_bottom: 'Долу',
  command_intelligence_panel_layout: 'Оформление на панела',
  command_intelligence_panel_layout_overlap: 'Залагане върху съдържанието',
  command_intelligence_panel_layout_push: 'Избутване на съдържанието',
  command_intelligence_panel_auto_hide_overlap: 'Автоматично скриване при клик извън',
  command_intelligence_session_reset: 'Нулирай разговора',
  command_intelligence_try_one_of_these: 'Опитайте едно от тези',
  command_intelligence_attach_hint: 'Прикачете контекстни елементи, за да започнете да задавате въпроси.',
  command_intelligence_welcome_subhead: 'Задайте въпрос, за да започнете.',
  command_intelligence_attach_modal_title: 'Прикачи контекст',
  command_intelligence_attach_modal_subtitle:
    'Изберете от елементите в този изглед. Вече прикачените елементи са избледнели.',
  command_intelligence_attach_modal_search_placeholder: 'Търсене…',
  command_intelligence_attach_modal_pool:
    '{count, plural, one {# елемент наличен} other {# елемента налични}} · избрани {selected}',
  command_intelligence_attach_modal_empty: 'Няма налични елементи за прикачване',
  command_intelligence_attach_modal_no_results: 'Нито един елемент не съответства на търсенето',
  command_intelligence_context_bar_attached_section: 'Прикачени ({count})',
  command_intelligence_context_bar_clear_attached: 'Изчисти',
  command_intelligence_context_bar_add: 'Прикачи контекст',
  command_intelligence_placeholder_ready: 'Задайте въпрос…',
  command_intelligence_placeholder_attach: 'Прикачете контекст, за да зададете въпрос…',
  command_intelligence_composer_submit_hint: 'Enter за изпращане · Shift+Enter за нов ред',
  command_intelligence_composer_stop_hint: 'Спри · чернова на следващото съобщение докато чакате',
  command_intelligence_response_stopped: 'Отговорът е спрян',
  command_intelligence_generation_in_progress: 'Обработва се въпросът ви',
  command_intelligence_generation_trace_title: 'Изпълнени стъпки',
  command_intelligence_generation_trace_toggle: 'Покажи стъпките',
  command_intelligence_generation_trace_summary: '{completed} от {total} стъпки завършени',
  command_intelligence_generation_trace_summary_generic: 'Стъпки на генериране',
  command_intelligence_generation_tool_count: '{count, plural, one {# инструмент} other {# инструмента}}',
  command_intelligence_generation_turn_label: 'Ход {turn} от {total}',
  command_intelligence_generation_turn_completed: 'Завършен ход {turn} от {total}',
  command_intelligence_generation_turn_completed_elapsed: 'Завършен ход {turn} от {total} ({seconds}s изминали)',
  command_intelligence_generation_turn_completed_with_tools: 'Завършен ход {turn} от {total} – използвани {tools}',
  command_intelligence_generation_tools_used: 'Използвани {tools}',
  command_intelligence_reasoning_thinking: 'Мисля…',
  command_intelligence_reasoning_thought_for_seconds: 'Мисли {seconds} секунди',
  command_intelligence_reasoning_waiting: 'Обработва се въпросът ви…',
  command_intelligence_attach_modal_done: 'Готово',
  command_intelligence_attach_modal_attached_badge: 'прикачен',
  command_intelligence_attach_modal_attach: 'Прикачи',
  command_intelligence_attach_modal_attach_count: 'Прикачи ({count})',
  command_intelligence_attach_modal_close_aria: 'Затвори селектора',
  command_intelligence_session_limit_context: 'Достигнат лимит на контекста. Нулирайте разговора, за да продължите.',
  command_intelligence_session_limit_prompt: 'Достигнат лимит на съобщенията. Нулирайте разговора, за да продължите.',
  command_intelligence_suggested_followups: 'Предложени последващи въпроси',
  command_intelligence_credit_warning_line: '{pct}% от месечните AI кредити за {scope} използвани',
  command_intelligence_tooltip_prompts: '{count} от {max} съобщения ({pct}%)',
  command_intelligence_tooltip_context: '{used} от {max} контекстни токени ({pct}%)',
  command_intelligence_tooltip_context_idle: 'Използването на контекста се появява след първия отговор',
  command_intelligence_credits_loading: 'Зареждане на кредити…',
  command_intelligence_credits_unavailable: 'Кредитите не са налични',
  command_intelligence_credits_tooltip: 'Месечни AI кредити за {monthKey}',
  command_intelligence_credits_tooltip_short: 'Месечни AI кредити',
  command_intelligence_credits_scope_profile: 'Профил',
  command_intelligence_credits_scope_entity: 'Обект',
  command_intelligence_credits_used_of_cap: '{used} от {cap} кредита',
  command_intelligence_credits_used_no_cap: '{used} кредита използвани',
  command_intelligence_credits_monthly_title: 'Месечни AI кредити',
  command_intelligence_compare_aria: 'Сравни агенти',
  command_intelligence_compare_tooltip: 'Изпълни същия въпрос срещу няколко профила на агенти',
  command_intelligence_compare_cancelled: 'Сравнението е отменено',
  command_intelligence_compare_branch_failed: 'Клонът за сравнение е неуспешен',
  command_intelligence_compare_title: 'Сравнение на агенти',
  command_intelligence_compare_stats: '{durationMs} ms · {model} · {inTok} вх. / {outTok} изх. · {agentRef}',
  command_intelligence_compare_error: '{message}',
  command_intelligence_profile_agent: '{agentRef}',
  command_intelligence_feedback_good_response: 'Добър отговор',
  command_intelligence_feedback_bad_response: 'Лош отговор',
  command_intelligence_feedback_dialog_title: 'Дайте обратна връзка',
  command_intelligence_feedback_dialog_body:
    'Помогнете ни да се подобрим, като дадете обратна връзка за този отговор. Вашата обратна връзка ще бъде изпратена до нашия оперативен екип.',
  command_intelligence_feedback_response_label: 'Отговор',
  command_intelligence_feedback_input_label: 'Вашата обратна връзка (по избор)',
  command_intelligence_feedback_input_placeholder: 'Какво беше грешно или неполезно в този отговор?',
  command_intelligence_feedback_submit: 'Изпрати обратна връзка',
  command_intelligence_feedback_submit_error: 'Неуспешно изпращане на обратна връзка. Опитайте отново.',
  command_intelligence_feedback_question_understanding: 'Разбра ли агентът какво искахте?',
  command_intelligence_feedback_question_readability: 'Беше ли отговорът лесен за четене и използване?',
  command_intelligence_feedback_section_understanding: 'Разбиране',
  command_intelligence_feedback_section_readability: 'Четимост',
  command_intelligence_feedback_choice_none: 'Няма',
  command_intelligence_feedback_choice_misunderstood_task: 'Неправилно разбрана задача',
  command_intelligence_feedback_choice_ignored_constraint: 'Игнорирано ограничение',
  command_intelligence_feedback_choice_wrong_scope: 'Грешен обхват',
  command_intelligence_feedback_choice_visually_hard_to_read: 'Визуално трудно за четене',
  command_intelligence_feedback_choice_wrote_too_much: 'Написа твърде много',
  command_intelligence_feedback_choice_explanation_not_trustworthy: 'Обяснението не е надеждно',
  command_intelligence_copy_aria: 'Копирай в клипборда',
  command_intelligence_error_missing_invoke_permission:
    'Нямате разрешение да използвате Command Intelligence за този агент. Помолете администратора да предостави необходимите Intelligence разрешения (например analyst).',
  command_intelligence_access_denied_title: 'Необходим е достъп',
  command_intelligence_error_session_expired: 'Сесията ви е изтекла. Опреснете страницата и влезте отново.',
};
